(() => {
  if (window.mwBundleEventsReady) return;
  window.mwBundleEventsReady = true;

  const getProductComponent = element => element.closest('[data-js-product-component]');

  const getQuantityInput = productComponent => {
    if (!productComponent) return null;
    return productComponent.querySelector('[data-js-product-quantity] input[name="quantity"]');
  };

  const formatMoney = cents => {
    const format = window.KROWN && KROWN.settings ? KROWN.settings.shop_money_format : '{{amount}}';
    const isoCode = window.KROWN && KROWN.settings ? KROWN.settings.iso_code || '' : '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;

    const formatWithDelimiters = (value, precision = 2, thousands = ',', decimal = '.') => {
      const number = Number(value);
      if (!Number.isFinite(number)) return '0';
      const parts = (number / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, `$1${thousands}`);
      return parts[1] ? `${parts[0]}${decimal}${parts[1]}` : parts[0];
    };

    const match = format.match(placeholderRegex);
    if (!match) return `${formatWithDelimiters(cents)}${isoCode}`;

    let value = '';
    switch (match[1]) {
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
      case 'amount_with_apostrophe_separator':
        value = formatWithDelimiters(cents, 2, "'", '.');
        break;
      default:
        value = formatWithDelimiters(cents, 2);
    }

    return `${format.replace(placeholderRegex, value)}${isoCode}`;
  };

  const updateDynamicPrice = (productComponent, quantity, activeTier) => {
    const price = productComponent ? productComponent.querySelector('[data-mw-dynamic-price]') : null;
    if (!price) return;

    const unitPrice = parseInt(price.dataset.unitPrice, 10) || 0;
    const comparePrice = parseInt(price.dataset.comparePrice, 10) || 0;
    const discount = activeTier ? parseFloat(activeTier.dataset.discount) || 0 : 0;
    const hasVolumeDiscount = discount > 0;
    const pricingQuantity = hasVolumeDiscount ? quantity : 1;
    const unitDiscount = Math.round(unitPrice * discount / 100);
    const discountedUnitPrice = unitPrice - unitDiscount;
    const totalPrice = discountedUnitPrice * pricingQuantity;
    const referenceUnitPrice = comparePrice > unitPrice ? comparePrice : unitPrice;
    const referenceTotal = referenceUnitPrice * pricingQuantity;
    const saving = Math.max(referenceTotal - totalPrice, 0);
    const totalElement = price.querySelector('[data-mw-price-total]');
    const unitElement = price.querySelector('[data-mw-price-unit]');
    const summaryElement = price.querySelector('[data-mw-price-summary]');
    const compareElement = price.querySelector('[data-mw-price-compare]');
    const savingElement = price.querySelector('[data-mw-price-saving]');

    if (totalElement) totalElement.textContent = formatMoney(totalPrice);

    if (unitElement) {
      unitElement.textContent = `${formatMoney(discountedUnitPrice)}${price.dataset.perPieceSuffix || ''}`;
      unitElement.hidden = !hasVolumeDiscount;
    }

    if (summaryElement) {
      summaryElement.hidden = saving <= 0 || !savingElement;
    }

    if (compareElement) compareElement.textContent = formatMoney(referenceTotal);

    if (savingElement) {
      if (price.dataset.savingDisplay === 'percent') {
        const savingPercent = referenceTotal > 0 ? Math.round(saving * 100 / referenceTotal) : 0;
        savingElement.textContent = `-${savingPercent}%`;
      } else {
        savingElement.textContent = formatMoney(saving);
      }
    }
  };

  const updateBundleSelection = productComponent => {
    const quantityInput = getQuantityInput(productComponent);
    const bundle = productComponent ? productComponent.querySelector('[data-bundle-discount]') : null;
    if (!quantityInput) return;

    const currentQuantity = parseInt(quantityInput.value, 10) || 1;
    let activeInput = null;

    if (bundle) {
      bundle.querySelectorAll('.v-bundle-input').forEach(input => {
        const tierQuantity = parseInt(input.dataset.quantity, 10);
        const activeQuantity = activeInput ? parseInt(activeInput.dataset.quantity, 10) : 0;
        if (currentQuantity >= tierQuantity && tierQuantity > activeQuantity) activeInput = input;
        input.checked = false;
      });

      if (activeInput) activeInput.checked = true;
    }

    updateDynamicPrice(productComponent, currentQuantity, activeInput);
  };

  const setQuantity = (productComponent, quantity) => {
    const quantityInput = getQuantityInput(productComponent);
    if (!quantityInput) return;

    quantityInput.value = Math.max(parseInt(quantity, 10) || 1, 1);
    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    updateBundleSelection(productComponent);
  };

  document.addEventListener('change', event => {
    if (event.target.matches('.v-bundle-input') && event.target.checked) {
      setQuantity(getProductComponent(event.target), event.target.dataset.quantity);
      return;
    }

    if (event.target.matches('[data-js-product-quantity] input[name="quantity"]')) {
      updateBundleSelection(getProductComponent(event.target));
    }
  });

  document.addEventListener('input', event => {
    if (event.target.matches('[data-js-product-quantity] input[name="quantity"]')) {
      updateBundleSelection(getProductComponent(event.target));
    }
  });

  document.addEventListener('click', event => {
    const quantityButton = event.target.closest('.mw-product-quantity .qty-minus, .mw-product-quantity .qty-plus');
    if (!quantityButton) return;
    const productComponent = getProductComponent(quantityButton);
    requestAnimationFrame(() => updateBundleSelection(productComponent));
  });

  document.addEventListener('krown:variant:change', event => {
    const productComponent = event.detail && event.detail.productForm
      ? event.detail.productForm.closest('[data-js-product-component]')
      : null;
    requestAnimationFrame(() => {
      if (productComponent) updateBundleSelection(productComponent);
    });
  });

  document.querySelectorAll('[data-js-product-component]').forEach(updateBundleSelection);
})();
